import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = { class: "label-input" }
const _hoisted_3 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["custom-select", { disabled: _ctx.isDisabled }])
    }, [
      _createElementVNode("input", {
        type: "date",
        class: "date-input",
        value: _ctx.value,
        disabled: _ctx.isDisabled,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateDate($event.target.value)))
      }, null, 40, _hoisted_3)
    ], 2),
    _createElementVNode("p", {
      class: _normalizeClass([_ctx.hasError ? 'error' : 'no-error'])
    }, _toDisplayString(_ctx.hasError ? _ctx.error?.esMessage : ""), 3)
  ]))
}